// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BackupPriority_TheComp__m3lSz"};